import { render, staticRenderFns } from "./DowntimeAlert.vue?vue&type=template&id=332a3a6c&scoped=true"
import script from "./DowntimeAlert.vue?vue&type=script&lang=js"
export * from "./DowntimeAlert.vue?vue&type=script&lang=js"
import style0 from "./DowntimeAlert.vue?vue&type=style&index=0&id=332a3a6c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332a3a6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/bamboo-agent-home/xml-data/build-dir/MEM-MEMUI-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('332a3a6c')) {
      api.createRecord('332a3a6c', component.options)
    } else {
      api.reload('332a3a6c', component.options)
    }
    module.hot.accept("./DowntimeAlert.vue?vue&type=template&id=332a3a6c&scoped=true", function () {
      api.rerender('332a3a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/alert/DowntimeAlert.vue"
export default component.exports